import { useEffect, useState } from "react";
import { http } from "@/lib/api";
import { Quote } from "lucide-react";

export default function Testimonials({ accent = "#00FFC2", title = "From operators in the network" }) {
  const [items, setItems] = useState([]);
  useEffect(() => { http.get("/testimonials").then(({ data }) => setItems(data.items)); }, []);

  if (!items.length) return null; // hide entirely until admin adds some

  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20" data-testid="testimonials-section">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-12">
        <h2 className="lg:col-span-7 text-4xl sm:text-5xl font-black tracking-tight font-display-ai">
          {title.split(" ").slice(0, -2).join(" ")}{" "}
          <span style={{ color: accent }}>{title.split(" ").slice(-2).join(" ")}.</span>
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map((t) => (
          <article key={t.id} className="glass rounded-xl p-7" data-testid={`testimonial-${t.id}`}>
            <Quote size={20} style={{ color: accent }} />
            <p className="text-base text-gray-200 leading-relaxed mt-4">"{t.quote}"</p>
            <div className="mt-6 flex items-center gap-3 border-t hairline pt-4">
              {t.avatar_url ? (
                <img src={t.avatar_url} alt={t.name} className="w-10 h-10 rounded-full object-cover" />
              ) : (
                <div className="w-10 h-10 rounded-full grid place-items-center text-xs font-bold" style={{ background: accent + "22", color: accent }}>
                  {t.name?.[0]?.toUpperCase() || "?"}
                </div>
              )}
              <div>
                <div className="text-sm font-semibold">{t.name}</div>
                {t.title && <div className="text-xs text-gray-400">{t.title}</div>}
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
